import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Movie from "./Movies";
import Book from "./bookMovie";
import Navbar from "./Navbars";
import Seat from "./Seats";
import Payment from "./payment";
class Mains extends Component {
  state = {
    region: "",
  };
  handleNavSearch = (query) => {
    let user;
    user = { query: query };
    this.setState({ user });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      if (this.props.match) {
        this.setState({ region: this.props.match.params.region });
      }
    }
  }
  render() {
    let region = this.props.match ? this.props.match.params.region : "NCR";
    let qu = this.state.user ? this.state.user.query : "";
    let pathname = this.state.user
      ? "/movies/region?q=" + this.state.user.query
      : "/movies/region";

    console.log(pathname);
    return (
      <div className="container-fluid">
        <Switch>
          <Route
            path="/bookMovie/:region/:id/buyTicket/:rid/:selid/:dateid"
            component={Seat}
          ></Route>
          <Route path="/movies/:region" component={Movie}></Route>
          <Route path="/payment" component={Payment}></Route>
          <Route path="/movies" component={Movie}></Route>
          <Route path="/bookMovie/:region/:id" component={Book}></Route>
          <Redirect to="/movies/NCR"></Redirect>
        </Switch>
      </div>
    );
  }
}

export default Mains;
